import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "add-page common-page"
};
import { reactive, ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import separateUpload from '@/components/separate-upload.vue';
import basicEditor from '@/components/basic-editor.vue';
import { ElMessage, ElForm } from 'element-plus';
import { getAllTagListApi, addArticeApi, getArticeDescApi, updateArticeApi } from '@/service/modules/artice';
export default /*@__PURE__*/_defineComponent({
  __name: 'add',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const formRef = ref();
    const form = reactive({
      title: '',
      type: 'index',
      text: '',
      tag: [],
      cover_url: ''
    });
    const tagList = ref([]);
    const isLoading = ref(false);
    const id = ref(null);
    const formRules = {
      title: [{
        required: true,
        message: '请输入标题',
        trigger: 'blur'
      }],
      type: [{
        required: true,
        message: '请选择文章类型',
        trigger: 'blur'
      }],
      tag: [{
        required: true,
        message: '请选择文章分类',
        trigger: 'blur'
      }],
      text: [{
        required: true,
        message: '请输入内容',
        trigger: 'blur'
      }]
    };
    getAllTagList();
    async function getAllTagList() {
      try {
        let res = await getAllTagListApi();
        tagList.value = res.data[0].category;
      } catch {}
    }
    function handleUploadImg(img) {
      form.cover_url = img;
    }
    function handleIntroChange(val) {
      form.text = val;
    }
    function handleToBack() {
      if (isLoading.value) {
        return ElMessage.warning('正在保存~~');
      }
      router.back();
    }
    function handleSubmit() {
      formRef.value?.validate(validate => {
        if (validate) {
          submit();
        }
      });
    }
    async function submit() {
      isLoading.value = true;
      let query = JSON.parse(JSON.stringify(form));
      try {
        if (form.type === 'index') {
          query.tag = 'index';
        } else if (form.type === 'kangyang') {
          query.tag = query.tag.join('-');
        }
        console.log('query', query);
        if (id.value) {
          await updateArticeApi(id.value, query);
          ElMessage.success('修改成功');
        } else {
          await addArticeApi(query);
          ElMessage.success('添加成功');
        }
        setTimeout(() => {
          router.back();
        }, 600);
      } catch (e) {
        console.log('e', e);
      } finally {
        isLoading.value = false;
      }
    }
    async function getDescById(id) {
      try {
        let {
          data
        } = await getArticeDescApi(id);
        form.title = data.title;
        form.cover_url = data.cover_url;
        form.text = data.text;
        if (data.tag === 'index') {
          form.type = 'index';
          form.tag = [];
          form.text = data.text;
        } else {
          form.type = 'kangyang';
          form.tag = data.tag.split('-');
        }
      } catch {}
    }
    onMounted(() => {
      let query = route.query;
      if (query?.id) {
        id.value = query.id;
        getDescById(id.value);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElForm), {
        "label-position": "left",
        "label-width": "100px",
        rules: formRules,
        ref_key: "formRef",
        ref: formRef,
        model: form
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "文章标题",
          prop: "title"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.title = $event),
            placeholder: "请输入标题"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "文章类型",
          prop: "type"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: form.type,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.type = $event),
            class: "ml-4"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: "index"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("养生知识")])),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: "kangyang"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("康养教育")])),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), form.type === 'kangyang' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "文章分类",
          prop: "tag"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_cascader, {
            style: {
              "width": "100%"
            },
            modelValue: form.tag,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.tag = $event),
            options: tagList.value,
            props: {
              expandTrigger: 'click',
              label: 'name',
              value: 'key'
            },
            placeholder: "请选择分类"
          }, null, 8, ["modelValue", "options"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
          label: "文章封面"
        }, {
          default: _withCtx(() => [_createVNode(separateUpload, {
            img1Url: form.cover_url,
            onUploadSuccess: handleUploadImg
          }, null, 8, ["img1Url"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "文章内容",
          prop: "text"
        }, {
          default: _withCtx(() => [_createVNode(basicEditor, {
            onIntroChange: handleIntroChange,
            data: form.text
          }, null, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "danger",
            style: {
              "margin-right": "10px"
            },
            size: "default",
            onClick: handleToBack
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("返回")])),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            size: "default",
            loading: isLoading.value,
            onClick: handleSubmit
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("确定")])),
            _: 1
          }, 8, ["loading"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]);
    };
  }
});